import { useNavigate, useParams } from 'react-router-dom'
import DTCMappingSection from '../../../../components/dtcs/TATMappings/ConnectorMapping/DTCMappingSection'
import SearchConnectorSection from '../../../../components/dtcs/TATMappings/ConnectorMapping/SearchConnectorSection'
import DtcsHeader from '../../../../components/dtcs/TATMappings/DtcsHeader'
import { useContext } from 'react'
import { NavContext } from '../../../../context/global_context'

const TatDtcMappings = () => {
  let { vehicle } = useParams()
  const navigate = useNavigate()
  const [value] = useContext(NavContext)

  return (
    <>
      {value?.dtc_details?.length > 0 && (
        <DtcsHeader dtcs={value?.dtc_details} vehicleSid={value?.vehicle} />
      )}
      <div className="flex items-stretch flex-grow" style={{ height: '90vh' }}>
        <SearchConnectorSection />
        <div className="flex-1 w-1/3 flex flex-col px-4 py-2 bg-tracer-darker-blue flex-grow"></div>
        <DTCMappingSection />
      </div>
      <div className="flex justify-center">
        <input
          type="button"
          className={`cursor-pointer btn danger my-4 px-5`}
          style={{ width: 100 }}
          onClick={(e) => navigate(`/vehicles/${vehicle}/dtcs/listing`)}
          value="Cancel"
        />
      </div>
    </>
  )
}

export default TatDtcMappings
